import { useState, useEffect } from 'react';
import {
  Container,
  BoxSelect,
  BtnSearch,
  Content,
  Title
} from './styled';
import { DatePicker } from '../../../../components';
import moment from 'moment';
import { IoIosSearch } from 'react-icons/io';
import { apiAdmin } from '../../../../service/api';
import { IoAnalyticsOutline } from "react-icons/io5";
import { Chart } from './Chart';

export function PeakAttendance() {

  const [parameters, setParameters] = useState({
    startDate: moment().subtract(1, 'months').format('YYYY-MM-DD'),
    finishDate: moment().format('YYYY-MM-DD'),
  });
  const [loading, setLoading] = useState(false);
  const [dataAttendance, setDataAttendance] = useState([]);

  const searchAttendance = async (parameters) => {
    const dt_ini = moment(parameters.startDate).format('DD/MM/yyyy');
    const dt_fim = moment(parameters.finishDate).format('DD/MM/yyyy');
    try {
      setLoading(true);
      setDataAttendance([]);
      const { data } = await apiAdmin.post(`/atendimentos-hora?dt_ini=${dt_ini}&dt_fim=${dt_fim}&tipo_relatorio=${'S'}`);

      setDataAttendance(data.atendimentos || []);
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    searchAttendance(parameters);
  }, []);

  useEffect(() => {
    setDataAttendance([]);
  }, [parameters]);

  return (
    <Container>
      <BoxSelect>
        <div className='box--'>
          <div className='line-'>
            <DatePicker
              className="date"
              value={parameters.startDate}
              onChange={(value) => setParameters((prev) => ({
                ...prev,
                startDate: value
              }))}
            />
            <span> - </span>
            <DatePicker
              className="date"
              value={parameters.finishDate}
              onChange={(value) => setParameters((prev) => ({
                ...prev,
                finishDate: value
              }))}
            />
            <BtnSearch
              disabled={loading ? 1 : 0}
              onClick={() => {
                searchAttendance(parameters);
              }}
            >
              {loading
                ? <span className='loader' />
                : <IoIosSearch />
              }
            </BtnSearch>
          </div>
        </div>
      </BoxSelect>
      <Content>
        <Title>
          <span>
            <IoAnalyticsOutline fontSize={'3rem'} />
          </span>
          <div>
            {`Pico de Atendimentos`}
          </div>
        </Title>
        <div className='--chart'>
          <Chart
            user={dataAttendance}
            objKey="hr"
            className="chart-container"
          />
        </div>
      </Content>
    </Container>
  );
}